// Slug parsing helpers for the SEO-friendly category/location landing
// routes (/tutors/:location/:subject, /tutors/:combinedSlug,
// /adult-education/:serviceSlug, /training-centres/:location). These are
// thin routing wrappers around SearchResults — the values produced here
// become its presetCategory/presetSubject/presetLocation props.

// Maps a URL-friendly category slug prefix to the real category group name
// used server-side (must match PROGRAM_CATEGORIES group names in
// tutorPrograms.js exactly).
export const CATEGORY_SLUG_MAP = {
  "adult-education": "Adult Education",
  waec: "WAEC/NECO",
  neco: "WAEC/NECO",
  jamb: "JAMB",
};

// Converts a kebab-case URL segment into a human-readable Title Case
// string — best-effort, used for free-text location/subject filters that
// aren't backed by a fixed taxonomy.
export const humanizeSlug = (slug = "") =>
  slug
    .split("-")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

// Parses a combined "/tutors/:combinedSlug" segment like "waec-english" or
// "jamb-mathematics" into { category, subject } by matching the longest
// known category slug prefix; whatever remains becomes the subject.
export const parseCombinedSlug = (combinedSlug = "") => {
  const normalized = (combinedSlug || "").toLowerCase();
  const prefixes = Object.keys(CATEGORY_SLUG_MAP).sort(
    (a, b) => b.length - a.length,
  );
  const prefix = prefixes.find(
    (p) => normalized === p || normalized.startsWith(`${p}-`),
  );

  if (!prefix) {
    return { category: "", subject: humanizeSlug(normalized) };
  }

  const remainder = normalized.slice(prefix.length).replace(/^-/, "");
  return {
    category: CATEGORY_SLUG_MAP[prefix],
    subject: remainder ? humanizeSlug(remainder) : "",
  };
};

// Parses "/adult-education/:serviceSlug" like "reading-tutors" into a
// subject under the "Adult Education" category by stripping a trailing
// "-tutor"/"-tutors" suffix.
export const parseAdultEducationServiceSlug = (serviceSlug = "") => {
  const normalized = (serviceSlug || "").toLowerCase().replace(/-tutors?$/, "");
  return humanizeSlug(normalized);
};
